import { Form, Switch, Tooltip } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import type { TheaterBannerConfig } from '@/types/theater-banner';

type Props = {
    settings: Pick<TheaterBannerConfig, 'enabled'>;
    disabled?: boolean;
    hasItems?: boolean;
    onChange: (settings: Pick<TheaterBannerConfig, 'enabled'>) => void;
};

/**
 * 有剧集：可手动开/关；
 * 无剧集：强制关，且不可手动开（保存时也会写成 enabled=false）。
 */
const GlobalSettings: React.FC<Props> = ({ settings, disabled, hasItems = false, onChange }) => {
    const { formatMessage } = useIntl();
    const empty = !hasItems;
    const switchNode = (
        <Switch
            checked={!empty && Boolean(settings.enabled)}
            disabled={disabled || empty}
            onChange={(enabled) => {
                if (empty) return;
                onChange({ enabled });
            }}
        />
    );

    return (
        <Form layout="inline" disabled={disabled}>
            <Form.Item label={<FormattedMessage id="clientBanner.settings.enabled" />}>
                {empty ? (
                    <Tooltip title={formatMessage({ id: 'clientBanner.settings.enabledRequiresItems' })}>
                        <span>{switchNode}</span>
                    </Tooltip>
                ) : (
                    switchNode
                )}
            </Form.Item>
        </Form>
    );
};

export default GlobalSettings;
